import { DivProps } from '@commonTypes'

interface IProps {
  editing: boolean
  children: JSX.Element[]
}

export default function Editable({ children, editing }: IProps & DivProps) {
  const c = editing ? children[1] : children[0]
  return c
}
